import { z } from 'zod'

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 20

export const UsernameSchema = z
	.string({ required_error: 'Numele de utilizator este obligatoriu' })
	.min(USERNAME_MIN_LENGTH, { message: 'Numele de utilizator este prea scurt' })
	.max(USERNAME_MAX_LENGTH, { message: 'Numele de utilizator este prea lung' })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message: 'Numele de utilizator poate conține doar litere, cifre și underscore',
	})
	// users can type the username in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'Parola este obligatorie' })
	.min(6, { message: 'Parola este prea scurtă' })
	// NOTE: bcrypt has a limit of 72 bytes (which should be plenty long)
	// https://github.com/epicweb-dev/epic-stack/issues/918
	.refine((val) => new TextEncoder().encode(val).length <= 72, {
		message: 'Parola este prea lungă',
	})

export const NameSchema = z
	.string({ required_error: 'Numele este obligatoriu' })
	.min(3, { message: 'Numele este prea scurt' })
	.max(40, { message: 'Numele este prea lung' })

export const EmailSchema = z
	.string({ required_error: 'Emailul este obligatoriu' })
	.email({ message: 'Emailul nu este valid' })
	.min(3, { message: 'Emailul este prea scurt' })
	.max(100, { message: 'Emailul este prea lung' })
	// users can type the email in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Parolele trebuie să coincidă',
			})
		}
	})
